import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import type { ProductType } from '@xing-com/crate-common-graphql-types';
import { mediaWide } from '@xing-com/layout-tokens';
import { List } from '@xing-com/list';
import { spaceXL, spaceS } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

import { OfferBenefitItem } from './offer-benefit-item';

interface OfferBenefitsProps {
  benefitsList: readonly string[];
  product: ProductType;
  className?: string;
}

export function OfferBenefits({
  product,
  benefitsList,
  className = '',
}: OfferBenefitsProps): JSX.Element {
  const scrollToFeaturesOverview = (): void => {
    document.getElementById('features-overview')?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  return (
    <div className={className}>
      <StyledList>
        {benefitsList.map((benefit) => (
          <OfferBenefitItem key={benefit.split('').join('_')}>
            {benefit}
          </OfferBenefitItem>
        ))}
      </StyledList>
      <ViewAllBenefits>
        <TextButton
          data-testid="view-all-benefits"
          onClick={scrollToFeaturesOverview}
        >
          <BodyCopy
            as="span"
            size="medium"
            sizeConfined="medium"
            fontWeight="bold"
            noMargin
          >
            {product === 'projobs' ? (
              <FormattedMessage id="UPSELL_PURCHASE_OFFER_BOX_BENEFITS_LIST_ITEM_MORE_PROJOBS" />
            ) : (
              <FormattedMessage id="UPSELL_PURCHASE_OFFER_BOX_BENEFITS_LIST_ITEM_MORE" />
            )}
          </BodyCopy>
        </TextButton>
      </ViewAllBenefits>
    </div>
  );
}

const StyledList = styled(List)`
  @media ${mediaWide} {
    padding-right: 10%;
  }
`;
const ViewAllBenefits = styled.div`
  padding-left: ${spaceXL};
  padding-top: ${spaceS};
  padding-bottom: ${spaceS};
`;
